import React, { useEffect, useState } from 'react';
export function ProgressTracker() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const calculateProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progressPercentage = Math.min(Math.round(scrolled / documentHeight * 100), 100);
      setProgress(progressPercentage);
    };
    calculateProgress();
    window.addEventListener('scroll', calculateProgress);
    window.addEventListener('resize', calculateProgress);
    return () => {
      window.removeEventListener('scroll', calculateProgress);
      window.removeEventListener('resize', calculateProgress);
    };
  }, []);
  const circumference = 2 * Math.PI * 28;
  const strokeDashoffset = circumference - progress / 100 * circumference;
  return <div className="fixed top-16 sm:top-20 right-2 sm:right-4 z-50" data-id="element-65">
      <div className="bg-white rounded-full shadow-lg p-1.5 sm:p-2" data-id="element-66">
        <div className="relative w-12 h-12 sm:w-16 sm:h-16" data-id="element-67">
          <svg className="transform -rotate-90 w-12 h-12 sm:w-16 sm:h-16" data-id="element-68">
            {/* Background circle */}
            <circle cx="24" cy="24" r="20" stroke="#e5e7eb" strokeWidth="3" fill="white" className="sm:hidden" data-id="element-69" />
            <circle cx="32" cy="32" r="28" stroke="#e5e7eb" strokeWidth="4" fill="white" className="hidden sm:block" data-id="element-70" />
            {/* Progress circle */}
            <circle cx="24" cy="24" r="20" stroke="#22c55e" strokeWidth="3" fill="none" strokeDasharray={2 * Math.PI * 20} strokeDashoffset={2 * Math.PI * 20 - progress / 100 * 2 * Math.PI * 20} strokeLinecap="round" className="transition-all duration-300 ease-out sm:hidden" data-id="element-71" />
            <circle cx="32" cy="32" r="28" stroke="#22c55e" strokeWidth="4" fill="none" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" className="hidden sm:block transition-all duration-300 ease-out" data-id="element-72" />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-73">
            <span className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-74">
              {progress}%
            </span>
          </div>
        </div>
      </div>
    </div>;
}